import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { ReminderDataInterface } from 'src/app/models/reminder-data.interface';
import { EmailTemplate } from 'src/app/models/server/email-template';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormFocusDirective } from '@hub4b/directives/form-focus.directive';

@Component({
    selector: 'app-reminder-action-send-mail-data',
    templateUrl: './reminder-action-send-mail-data.component.html',
    styleUrls: ['./reminder-action-send-mail-data.component.scss'],
    imports: [FormsModule, FormFocusDirective, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule]
})
export class ReminderActionSendMailDataComponent implements ReminderDataInterface, OnInit {
    public faCircleInfo = faCircleInfo;

    public _data: string;

    set data(value: string) {
        this._data = value;
        this.fillForm();
    }

    get data(): string {
        this.fillData();
        return this._data;
    }

    public _templates: EmailTemplate[];

    @Input()
    set templates(value: EmailTemplate[]) {
        this._templates = value;
        this.fillForm();
    }

    public dataForm: UntypedFormGroup;

    constructor() {}

    ngOnInit(): void {
        this.dataForm = new UntypedFormGroup({
            templateId: new UntypedFormControl(null, Validators.required),
        });

        this.fillForm();
    }

    private fillForm() {
        if (this.dataForm) {
            if (this._data) {
                let dataObject = JSON.parse(this._data);

                if (this._templates) {
                    this.dataForm.get('templateId').setValue(dataObject.templateId);
                }
            }
        }
    }

    private fillData() {
        let dataObject: any = {};
        dataObject.templateId = this.dataForm.get('templateId').value;

        this._data = JSON.stringify(dataObject);
    }

    public isValid(): boolean {
        return this.dataForm?.valid;
    }
}
